import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CookieRunService } from '../../../services/cookie-run.service';

@Component({
  selector: 'jhi-cookies',
  templateUrl: './cookies.component.html',
})
export class CookiesComponent implements OnDestroy {
  url: string;

  constructor(private cookieRunService: CookieRunService, private router: Router) {
    this.url = this.router.url;
  }

  public ngOnDestroy(): void {
    this.cookieRunService.run(this.url);
  }
}
